import _ from 'lodash'
import { connect } from 'react-redux'
import { FormGroup } from 'reactstrap'

import { Dropdown, Checkbox } from 'common-components'
import { getAge } from 'quick-quote/insured-information/selectors'
import RiderPremium from 'quick-quote/product-common/coverage-plan/components/rider/rider-premium'
import RiderMessage from 'quick-quote/product-common/coverage-plan/components/rider/rider-validation-message'
import { getAvaliableOptionByAge } from 'quick-quote/product-common/coverage-plan/selectors'

const MCIRider = ({
  className,
  rider,
  riderChecked,
  disableForm,
  toggleRider,
  editRiderSumAssured,
  editRiderSelectedPlan,
  eligibilityErrors,
  validationErrors,
  additionalInformation,
  riderCampaignInformation,
  isRequire,
  areasOfCover,
  planOptions,
  ...props
}) => (
  <FormGroup className={`${className}`} {...props}>
    <div className="label">
      <Checkbox
        id={rider.code}
        checked={riderChecked}
        disabled={!rider.isSelectable || Boolean(rider.isReadOnly) || isRequire || disableForm}
        onChange={() => toggleRider(rider.code, !riderChecked)}
      >
        <span className="custom-control-description">
          {rider.name} ({rider.description})
        </span>
      </Checkbox>
    </div>
    {rider.isSelectable ? (
      <div className="options mhpwc">
        <Dropdown
          id={`rider-${rider.code}-option-0`}
          options={planOptions}
          disabled={!rider.isSelected || rider.isReadOnly}
          value={rider.selectedPlan.planCode}
          onChange={(value) => {
            const selectedPlan = _.find(rider.options[0].values, { planCode: value })
            if (selectedPlan) {
              editRiderSelectedPlan(rider.code, {
                planCode: selectedPlan.planCode,
                fullPlanCode: selectedPlan.fullPlanCode,
                text: selectedPlan.text,
              })
            }
          }}
        />

        <div className="mhpwc-second-line">
          <div className="mhpwc-second-line-first-item">
            <Dropdown
              options={areasOfCover}
              onChange={(value) => {}}
              value={rider.selectedPlan.areaOfCover}
              disabled={!rider.isSelected || rider.isReadOnly}
            />
          </div>
          <div className="link">→</div>

          <RiderPremium
            isSelected={rider.isSelected && rider.isSelectable}
            isSelectable={rider.isSelectable}
            premium={rider.fullPremium ? rider.fullPremium : rider.premium}
          />
        </div>
      </div>
    ) : (
      <div className="options mhpwc">
        <div id={`rider-${rider.code}-option-0`} className="value-pair mhpwc-full-line">
          -
        </div>

        <div className="mhpwc-second-line">
          <div className="mhpwc-second-line-first-item">
            <div id={`rider-${rider.code}-option-1`} className="value-pair">
              -
            </div>
          </div>
          <div className="link">→</div>

          <RiderPremium
            isSelected={rider.isSelected && rider.isSelectable}
            isSelectable={rider.isSelectable}
            premium={rider.fullPremium ? rider.fullPremium : rider.premium}
          />
        </div>
      </div>
    )}

    <div className="message">
      <RiderMessage riderCode={rider.code} type="eligibility" messages={eligibilityErrors} />
      <RiderMessage riderCode={rider.code} type="validation" messages={validationErrors} />
      <RiderMessage riderCode={rider.code} type="rider-campaign-information" messages={riderCampaignInformation} />
      <RiderMessage riderCode={rider.code} type="additional-information" messages={additionalInformation} />
    </div>
  </FormGroup>
)

const mapStateToProps = (state) => ({
  insuredAge: getAge(state),
})

export default connect(mapStateToProps, {}, (stateProps, dispatchProps, ownProps) => {
  const { insuredAge } = stateProps
  const { rider, editRiderSumAssured, editRiderSelectedPlan } = ownProps
  const displayOptions = getAvaliableOptionByAge(rider, insuredAge)

  const planOptions = _.map(displayOptions, (option) => ({
    value: option.planCode,
    text: option.text,
  }))

  const areasOfCover = rider.areasOfCover
  return {
    ...ownProps,
    planOptions,
    areasOfCover,
  }
})(MCIRider)
